import { ChangeDetectionStrategy, Component, DestroyRef, inject, signal } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';

import { filter } from 'rxjs';

import { PopupService } from '@shared/services/popup.service';
import { PopupComponent } from '@shared/components/popup/popup.component';
import { SessionExpirationComponent } from '@shared/components/session-expiration/session-expiration.component';
import { SignInModalService } from '@shared/services/sign-in-modal.service';
import { SignInModalComponent } from '@shared/components/sign-in-modal/sign-in-modal.component';
import { ToastService } from '@shared/services/toast.service';
import { ToastComponent } from '@shared/components/toast/toast.component';

import { FooterComponent } from './pages/common/footer/footer.component';
import { HeaderComponent } from './pages/common/header/header.component';

@Component({
  selector: 'mdcr-root',
  imports: [
    RouterOutlet,
    HeaderComponent,
    FooterComponent,
    PopupComponent,
    SignInModalComponent,
    SessionExpirationComponent,
    ToastComponent,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  public readonly popupService = inject(PopupService);
  public readonly signInModalService = inject(SignInModalService);
  public readonly toastService = inject(ToastService);

  private readonly router = inject(Router);

  private readonly destroyRef = inject(DestroyRef);

  public readonly isHeaderAndFooterVisible = signal(true);
  public readonly isPopupOpened = this.popupService.isOpened;
  public readonly isSignInModalOpened = this.signInModalService.isOpened;
  public readonly isToastOpened = toSignal(this.toastService.getState(), {
    initialValue: false,
  });

  public readonly title = 'MedCare';

  constructor() {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe((event) => {
        const hideRoutes = [
          '/sign-up',
          '/sign-in',
          '/recover',
          '/sysadmin-panel',
          '/facility-portal',
          '/healthcare-facilities-filters',
          '/patient-portal',
          '/clinician-portal',
          '/forbidden',
        ];
        const shouldHide = hideRoutes.some((route) => event.urlAfterRedirects.includes(route));

        this.isHeaderAndFooterVisible.set(!shouldHide);
      });
  }
}
